import _ from "lodash";
import React from "react";
import { SideNavigation } from "@toddle-edu/ds-web";

const styles = {
  containerStyle: {
    maxWidth: "300px",
  },
};

const getSidebarOptions = ({ displayPrompts, t, language }) => {
  const root = {
    children: _.map(displayPrompts, "groupType"),
    key: "root",
  };

  const isEnglishLanguageSelected = language === "en";

  const childOptions = _.map(displayPrompts, prompt => {
    const { groupType, displayText, displayTextLocale } = prompt;

    return {
      key: groupType,
      title:
        isEnglishLanguageSelected || _.isNil(displayTextLocale)
          ? displayText
          : t(displayTextLocale),
      tier: 1,
      parent: "root",
      children: [],
    };
  });

  return [root, ...childOptions];
};

const SuggestedPromptsSidebar = props => {
  const {
    t,
    displayPrompts,
    onSelectedPromptCategoryChange,
    selectedPromptCategory,
    language,
  } = props;

  const sidebarOptions = getSidebarOptions({ displayPrompts, t, language });

  const onOptionClick = option => {
    onSelectedPromptCategoryChange(option);
  };

  return (
    <SideNavigation
      options={sidebarOptions}
      rootKey="root"
      theme="subtle"
      containerStyle={styles.containerStyle}
      selectedOptionKey={selectedPromptCategory}
      onClick={onOptionClick}
    />
  );
};

export default SuggestedPromptsSidebar;
